import { Injectable, signal } from '@angular/core';
import {
  CharterDocumentRequest,
  CharterProvenance,
  toDocumentRequest,
} from '@features/dashboard/company/corporate-charter/corporate-charter-provenance.util';

/**
 * Canal entre quem mostra uma procedência (`app-charter-provenance`, em qualquer cartão ou histórico) e o
 * visualizador do documento original (`app-charter-document-viewer`, montado uma vez na página). Provido pela página
 * do Societário: fora dela (ex.: bloco do Data Room), não há visualizador e a procedência só mostra o trecho.
 */
@Injectable()
export class CharterDocumentViewerService {
  /** Último pedido de abertura; o visualizador reage a cada pedido novo. */
  readonly request = signal<CharterDocumentRequest | null>(null);

  /** Abre o documento da procedência na página onde o valor está escrito. */
  open(source: CharterProvenance): void {
    const request = toDocumentRequest(source);
    if (request) {
      // Objeto novo a cada clique: abrir duas vezes o mesmo trecho também reabre o visualizador.
      this.request.set({ ...request });
    }
  }
}
